import { axInst } from "../../../Components/Login/Service";

export const mtd_offtake = async (body) => {
  try {
    const res = await axInst.post("offtake/mtd_offtake", body);
    return res.data.MTD_OFFTAKE.value;
  } catch (error) {
    console.error(error);
  }
};

export const today_offtake = async (body) => {
  try {
    const res = await axInst.post("offtake/todays_offtake", body);
    return res.data.TODAYS_OFFTAKE.value;
  } catch (error) {
    console.error(error);
  }
};

export const total_offtake = async (body) => {
  try {
    const res = await axInst.post("offtake/total_offtake", body);
    return res.data.TOTAL_OFFTAKE.value;
  } catch (error) {
    console.error(error);
  }
};
